import { Divider, Typography } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';

import { IViewSelectProps } from '../../types';

import { SelectButton, SelectIconButton, TagWrapper } from './styles';

export const ViewSelect = ({
  viewSelectProps,
  tagKey,
  hasOnlyDropdown,
  showDropdownWithSelect,
  onClick,
  openAnchorEl,
  ...wrapProps
}: IViewSelectProps) => {
  return (
    <TagWrapper {...viewSelectProps} $mainColor={wrapProps.mainColor} $selected={wrapProps.selected} id='custom-view'>
      <SelectButton
        disabled={wrapProps.selected}
        $isSelectable={hasOnlyDropdown}
        onClick={onClick}
        size='small'
        endIcon={hasOnlyDropdown && <ArrowDropDown />}
        data-testid={tagKey}
      >
        <Typography noWrap fontSize='0.85rem' fontWeight='bold'>
          {decodeURI(tagKey)}
        </Typography>
      </SelectButton>

      {showDropdownWithSelect && (
        <>
          <Divider orientation='vertical' flexItem />
          <SelectIconButton disableRipple onClick={openAnchorEl} size='small'>
            <ArrowDropDown fontSize='small' />
          </SelectIconButton>
        </>
      )}
    </TagWrapper>
  );
};
